//* 类型引入
import type { RouteRecordRaw } from "vue-router";

//* 路由配置解析
export const resolveRouteOption = (route: RouteRecordRaw, option: { routePrefix: string; routeLanguage: string }) => {
    //* 路由配置更新
    if (route.meta) {
        route.meta.route = route.name;
        route.meta.routeLanguage = option.routeLanguage;
    } else {
        route.meta = {
            routeLanguage: option.routeLanguage,
            route: route.name,
        };
    }

    //* 路由名称
    route.name = `${route.name?.toString() || ""}_${option.routeLanguage}`;
    //* 路由链接
    route.path = `${option.routePrefix}${route.path}`;
    //* 子路由
    if (route.children) {
        route.children = route.children.map((r) => resolveRouteOption(r, { routePrefix: route.path + "/", routeLanguage: option.routeLanguage }));
    }

    return route;
};
